/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-12-07 17:25:44
 * @LastEditTime: 2022-03-09 14:25:29
 * @FilePath: /teacher-h5/src/service/studentsDetails/index-url.js
 */
let baseUrl = ''
// const passportUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = ''
} else {
  baseUrl = 'https://jzx.aixuexi.com'
  // passportUrl = 'https://www.aixuexi.com'
}

export default {
  // 学习计划、自我巩固、错题本、学情报告列表
  groupDetailsList: () => `${baseUrl}/teaching/api/group/study/list`,
  // 小组年级、科目筛选框
  getSubjectGrade: ({ groupId }) => `${baseUrl}/teaching/api/group/study/subjectGrade/${groupId}`,
  // 生成小组学习计划副本
  copyGroupPlan: ({ groupId, planId }) => `${baseUrl}/teaching/api/lesson/copyPlan`,
  // 删除小组学习计划
  deletePlan: ({ groupId, planId }) => `${baseUrl}/teaching/api/lesson/deletePlan`,
  // 全员上课
  classBegin: ({ groupId, planId }) => `${baseUrl}/teaching/api/groupPlan/classBegin`,
  // 获取小组信息详情
  getGroupDetail: ({ groupId }) => `${baseUrl}/teaching/api/group/detail`
}
